import { createTablePageSlice } from "../helpers/createTablePageSlice";

export const ExhibitionsSlice = createTablePageSlice({
  reducerName: "exhibitions",
  getListEndpoint: "v1/admin/data/exhibitions",
});
